import { PharmacyDuty } from '@/apis/pharmacy/interface';
import { days } from '@/assets/data/timeList';
import moment from 'moment';
import 'moment/locale/ko';

export interface FormattedDutyType {
  weekDay: number;
  day: string;
  openTime: string;
  openHour: number;
  openMinute: number;
  closeTime: string;
  closeHour: number;
  closeMinute: number;
  isClosed: boolean;
}

export const localeMoment = moment;

export function formattedDate(
  date: Date | string | undefined,
  formatting: string
) {
  return moment(date)?.format(formatting) ?? '';
}

export const formatDutyTime = (duty?: Array<PharmacyDuty>) => {
  const dutyTime = duty?.map((day: PharmacyDuty) => {
    const openTime = day.openTime ? day.openTime.slice(0, 5) : '00:00';
    const closeTime = day.closeTime ? day.closeTime.slice(0, 5) : '00:00';
    const dayName = days[day.weekDay - 1];

    return {
      weekDay: day.weekDay,
      day: dayName,
      openTime,
      openHour: Number(openTime.split(':')[0]),
      openMinute: Number(openTime.split(':')[1]),
      closeTime,
      closeHour: Number(closeTime.split(':')[0]),
      closeMinute: Number(closeTime.split(':')[1]),
      isClosed: day.isClosed
    };
  });
  return dutyTime;
};

export const formatDutyTimeForSet = (duty: Array<FormattedDutyType>) => {
  const dutyTime = duty?.map((day: FormattedDutyType) => {
    const { weekDay, openHour, openMinute, closeHour, closeMinute, isClosed } =
      day;
    const openTime = `${String(openHour).padStart(2, '0')}:${String(
      openMinute
    ).padStart(2, '0')}`;
    const closeTime = `${String(closeHour).padStart(2, '0')}:${String(
      closeMinute
    ).padStart(2, '0')}`;
    return {
      weekDay,
      openTime,
      closeTime,
      isClosed
    };
  });
  return dutyTime;
};
